import React from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import intl from "react-intl-universal";
import { useField } from "formik";
import classNames from "classnames";

import { WITHBALL_DATA_CATEGORY_COLOR } from "MuiProvider";

import { STATS, FIELD } from "../constants";
import { IStatsValue, TEAM_TYPE } from "../types";

const useStyles = makeStyles(() => ({
  attack: {
    backgroundColor: WITHBALL_DATA_CATEGORY_COLOR.attack,
    width: "100%",
  },
  defense: {
    backgroundColor: WITHBALL_DATA_CATEGORY_COLOR.defence,
    width: "100%",
  },
  setball: {
    backgroundColor: WITHBALL_DATA_CATEGORY_COLOR.setball,
    width: "100%",
  },
  foul: {
    backgroundColor: WITHBALL_DATA_CATEGORY_COLOR.foul,
    width: "100%",
  },
  switch: {
    width: "100%",
  },
  selected: {
    border: "2px solid black",
  },
}));

export const StatButtons = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [actionField, actionMeta, { setValue: setActionTypeValue }] = useField(
    FIELD.action
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [methodField, methodMeta, { setValue: setActionMethod }] = useField(
    FIELD.method
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [teamTypeField, teamTypeMeta, { setValue: setTeamTypeValue }] =
    useField(FIELD.teamType);

  const classes = useStyles();

  const handleActionButtonClick = (value: IStatsValue) => () => {
    setActionTypeValue(value);
    setActionMethod(1);
  };

  const handleTeamSwitchButtonClick = () => {
    setTeamTypeValue(
      teamTypeField.value === TEAM_TYPE.HOME ? TEAM_TYPE.AWAY : TEAM_TYPE.HOME
    );
  };

  return (
    <>
      <Grid container spacing={1}>
        {STATS.filter((stat) => stat.category === "attack").map((button) => (
          <Grid item xs={2} key={button.name}>
            <Button
              className={classNames(
                classes.attack,
                button.name === actionField.value && classes.selected
              )}
              variant="contained"
              color="primary"
              size="small"
              onClick={handleActionButtonClick(button.name)}
            >{`${intl.get(button.i18nTag)}(${button.shortcutKey})`}</Button>
          </Grid>
        ))}
        <Grid item xs={2}>
          <Button
            className={classes.switch}
            variant="outlined"
            color="primary"
            size="small"
            onClick={handleTeamSwitchButtonClick}
          >{`${intl.get("STAT_ACTION_SWITCH")}(I)`}</Button>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        {STATS.filter((stat) => stat.category === "defence").map((button) => (
          <Grid item xs={2} key={button.name}>
            <Button
              className={classNames(
                classes.defense,
                button.name === actionField.value && classes.selected
              )}
              variant="contained"
              color="primary"
              size="small"
              onClick={handleActionButtonClick(button.name)}
            >{`${intl.get(button.i18nTag)}(${button.shortcutKey})`}</Button>
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={1}>
        {STATS.filter((stat) => stat.category === "setball").map((button) => (
          <Grid item xs={2} key={button.name}>
            <Button
              className={classNames(
                classes.setball,
                button.name === actionField.value && classes.selected
              )}
              variant="contained"
              color="primary"
              size="small"
              onClick={handleActionButtonClick(button.name)}
            >{`${intl.get(button.i18nTag)}(${button.shortcutKey})`}</Button>
          </Grid>
        ))}
        {STATS.filter((stat) => stat.category === "foul").map((button) => (
          <Grid item xs={2} key={button.name}>
            <Button
              className={classNames(
                classes.foul,
                button.name === actionField.value && classes.selected
              )}
              variant="contained"
              color="primary"
              size="small"
              onClick={handleActionButtonClick(button.name)}
            >{`${intl.get(button.i18nTag)}(${button.shortcutKey})`}</Button>
          </Grid>
        ))}
      </Grid>
    </>
  );
};
